/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button.is-info[_ngcontent-%COMP%]{border-color:unset;opacity:1}.button.disabled[_ngcontent-%COMP%]{opacity:.5}"];
export { styles as styles };
